import Occasion from '@repo/utils/helpers/Occasion';

export type TimeSeparator = { id: 'sectionHeader'; type: 'time-separator'; label: string };

export function addVirtualizedListTimeSeparators(items: Array<any>, dateKey: string) {
  const buckets = [
    { test: 'isToday', label: 'Today' },
    { test: 'isYesterday', label: 'Yesterday' },
    { test: 'isThisWeek', label: 'This Week' },
    { test: 'isLastWeek', label: 'Last Week' },
    { test: 'isThisMonth', label: 'This Month' },
    { test: 'isLastMonth', label: 'Last Month' },
    { test: null, label: 'Older' },
  ];

  let bucketIdx = 0;
  // We track these so we can ignore the separators during list navigation and row interactions
  const separatorIndices = [1];

  const timeSeparatedItems = items.reduce((items, item, idx) => {
    // In VirtualizedList, first item is a padding row
    if (idx === 0) return [item];

    const itemDate = new Occasion(item[dateKey]);

    if (idx === 1 || items.length === 1) {
      while (buckets[bucketIdx].test && !itemDate[buckets[bucketIdx].test]) {
        bucketIdx += 1;
      }

      return [...items, { id: 'sectionHeader', label: buckets[bucketIdx].label }, item];
    } else {
      if (bucketIdx === buckets.length - 1 || itemDate[buckets[bucketIdx].test]) {
        return [...items, item];
      }

      while (buckets[bucketIdx].test && !itemDate[buckets[bucketIdx].test]) {
        bucketIdx += 1;
      }

      separatorIndices.push(idx + separatorIndices.length);

      return [...items, { id: 'sectionHeader', label: buckets[bucketIdx].label }, item];
    }
  }, []);

  return { items: timeSeparatedItems, separatorIndices };
}

export function addTimeSeparators(items: Array<any>, dateKey: string) {
  const { items: timeSeparatedItems, separatorIndices } = addVirtualizedListTimeSeparators(
    [{ id: 'padding' }, ...items],
    dateKey,
  );

  let unpaddedItems = timeSeparatedItems.slice(1);
  let indexAdjustment = -1;
  const hasTodaySeparator = unpaddedItems.some((item) => item.label === 'Today');

  // if hasToday, remove the Today separator and adjust the indices by 2 instead of 1
  if (hasTodaySeparator > -1) {
    unpaddedItems = unpaddedItems.filter((item) => item.label !== 'Today');
    indexAdjustment = -2;
  }

  return {
    items: unpaddedItems,
    separatorIndices: separatorIndices.map((index) => index + indexAdjustment),
  };
}
